export class Novedad {
    id=""
    destinatarios="users"
    titulo=""
    descripcion=""
    imagen=""
    sendPush=false
}
